import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import styles from './styles'

const useStyles = makeStyles(styles)

/**
 * @typedef {{
 *   node: React.SVGProps<SVGPathElement>;
 *   fill: string;
 * }} SvgNodesProps
 *
 * @typedef {{
 *   data: {
 *     viewBox?: string;
 *     children: React.SVGProps<SVGPathElement>[];
 *   };
 *   color?: string;
 *   size?: string | number;
 * } & React.SVGProps<SVGPathElement>} SvgIconProps
 */

/**
 * @param {SvgNodesProps} props
 */
const SvgNodes = ({
  node,
  fill,
}) => {
  if (node.name === 'path') {
    return (
      <path {...node} fill={fill} />
    )
  }

  if (node.name === 'circle') {
    return (
      <circle {...node} fill={fill} />
    )
  }

  return null
}

/**
 * @param {SvgIconProps} props
 */
const SvgIcon = ({
  data,
  color = 'currentColor',
  size = '1.5rem',
  ...props
}) => {
  const classes = useStyles({ size })

  return (
    <svg
      viewBox={data.viewBox}
      className={classes.pickuppIcon}
      {...props}
    >
      {data.children.map((item, i) => (
        <SvgNodes
          key={i}
          node={item}
          fill={color}
        />
      ))}
    </svg>
  )
}

export default SvgIcon
